import React, { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { connect } from "react-redux"
import { Typography } from "@mui/material"
import { Delete as DeleteIcon } from "@mui/icons-material"
import { mapStateToProps, mapDispachToProps } from "../../../store/MapToProps"
import { getData, deleteProvider } from "../../../utils/helpers"
import UpdateProviderForm from "./UpdateProviderForm"

const UpdateData = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [isFetching, setFetching] = useState(false)
  const [providerId, setProviderId] = useState("")

  useEffect(() => {
    setProviderId(location.state.id)
    getData(props, location.state.pageTitle, location.state.id)
  }, []) // Added empty dependency array to useEffect

  const handleDeleteProvider = async () => {
    setFetching(true)
    await deleteProvider(providerId, navigate)
    setFetching(false)
  }

  return (
    <>
      <Typography variant="h4" noWrap component="div" sx={{ marginTop: "1em", marginBottom: "1.5em" }}>
        {`Update ${location.state.pageTitle}`}
        {location.state.pageTitle === "Provider" && (
          <DeleteIcon style={{ marginRight: "5px", marginLeft: "5px", color: "red" }} onClick={handleDeleteProvider} />
        )}
      </Typography>

      <UpdateProviderForm Provider={props?.providers?.data} enableLoader={props.enableLoder} />
    </>
  )
}

export default connect(mapStateToProps, mapDispachToProps)(UpdateData)

